
import React from 'react'

// eslint-disable-next-line react/prop-types
const DropdownArrow = ({className}) => (
    <svg className={className} width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.483429 0.0512078L3.82171 2.14718C3.928 2.2132 4.072 2.2132 4.17829 2.14718L7.51771 0.0669744C7.71886 -0.0581729 8 0.065989 8 0.278838V1.43473C8 1.51849 7.95314 1.59732 7.87429 1.64758L4.17829 3.95048C4.072 4.01651 3.928 4.01651 3.82171 3.95048L0.126857 1.64758C0.0468571 1.59732 0 1.51849 0 1.43473V0.263071C0 0.0482516 0.282286 -0.0759103 0.483429 0.0512078Z" fill="#41A017"/>
</svg>

  )

  export default DropdownArrow
